// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__1fd1E","androidDownload":"Login_androidDownload__hpijV","androidDownload__link":"Login_androidDownload__link__227eh"};